import { render, staticRenderFns } from "./AvailableSpots.vue?vue&type=template&id=5877cc80"
import script from "./AvailableSpots.vue?vue&type=script&lang=js"
export * from "./AvailableSpots.vue?vue&type=script&lang=js"
import style0 from "./AvailableSpots.vue?vue&type=style&index=0&id=5877cc80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports